import { ValueOf } from '@approvalmax/types';
import { SortOrder } from '@approvalmax/ui/src/components';
import { backend, domain } from 'modules/data';

export interface AddBillsPopupProps {
    companyId: string;
    accountId: string;
    billPaymentRequestId: string;
    currency: domain.NetSuiteCurrency;
    payeeId?: string;
    payeeType?: ValueOf<backend.NetSuitePayeeType> | null;
    togglePopup: VoidFunction;
}

export enum TableColumns {
    dateDue = 'dateDue',
    type = 'type',
    reference = 'reference',
    originalAmount = 'originalAmount',
    amountDue = 'amountDue',
    currency = 'currency',
    discountDate = 'discountDate',
    discountAvailable = 'discountAvailable',
}

export interface SortingConfig {
    sortBy: string;
    sortOrder: SortOrder;
}
